import React, {Component, Children, cloneElement} from 'react';
import AccountManager from 'lib/AccountManager';
import { render } from 'react-dom';
import PropTypes from 'prop-types';
import ParseApp from 'lib/ParseApp';
import history from 'dashboard/history';

export default class MetricsData extends Component {
  constructor(props) {
    super();

    this.state = {};
  }

  async componentDidMount() {
    const {currentUser, currentCustomer} = await AccountManager.currentUser();
    this.setState({currentUser, currentCustomer});
  }

  render() {
    if(Object.keys(this.state).length === 0) {
      return null;
    }

    const {render: renderFn, children: child} = this.props;

    return cloneElement(Children.only(child), {
      currentUser: this.state.currentUser,
      currentCustomer: this.state.currentCustomer,
      currentApp: this.context.currentApp,
    });
  }
}


MetricsData.contextTypes = {
  currentApp: PropTypes.instanceOf(ParseApp)
};
